/**
 *
 * @/services/api/http.js
 *
 */

//
// IMPORTS
//

import { checkInternetAvailability } from "@/services/api/network"
import { apiUrl } from '@/constants'
// import { backendUrl } from "@/utils/constants" // JESUS: Vem do app

//
// FUNCTIONS
//

const isHttpCodeValid = status => [200, 201, 204, 304, 400, 401, 403, 404, 409, 410, 422, 424, 429, 500].includes(status)

const localResponseObj = (reason, httpCode = 0) => ({
  httpCode,
  code: "LOCAL", // JESUS: Compatibilidade para atender apenas o apiDutyHandover por enquanto.
  title: "Atenção!",
  message: `A solicitação falhou. Por favor, tente novamente ou fale com o nosso suporte.${reason ? ` Motivo: ${reason}` : ""}`,
})

const offlineResponseObj = () => ({
  httpCode: 0,
  code: "LOCAL", // JESUS: Compatibilidade para atender apenas o apiDutyHandover por enquanto.
  title: "Atenção!",
  message: "A solicitaçao falhou, pois você está sem acesso a rede.\n\nRestabeleça a conexão e tente novamente.",
})

const parseJson = value => {
  try {
    return JSON.parse(value) || null
  } catch {
    return null
  }
}

//
//
//
// PROCESSADOR FETCH (JSON normal)
//
//
//

const httpRequestFetch = (args, url) => new Promise(resolve => {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 90000)

  // Monta as opções da requisição
  const options = {
    method: args.method,
    headers: {
      // "Content-Type": "application/json",
      "Accept": "application/json",
      ...(args.headers || {}),
    },
    signal: controller.signal,
  }

  if (args.fields && typeof args.fields === "object") {
    options.headers["Content-Type"] = "application/json"
    options.body = JSON.stringify(args.fields)
  }

  fetch(url, options).then(response => {
    clearTimeout(timeout)
    const httpCode = response.status
    // const httpCode = response.status || 0

    // ✅ LER HEADERS
    const responseHeaders = {}
    response.headers.forEach((value, key) => {
      responseHeaders[key.toLowerCase()] = value
    })

    if (httpCode === 204) {
      resolve({ httpCode, code: "OK", title: "Feito!", message: "", response_headers: responseHeaders })
      return
    }

    // Lê o corpo como texto (sempre retorna Promise)
    // tenta ler JSON apenas se houver conteúdo
    return response.text().then(text => {
      let processedResponse = text ? parseJson(text) : null

      console.log(`::: [DEBUG] ${args.method} ${url}:`, httpCode || 'load', processedResponse || text)

      // 304 do polling
      if (httpCode === 304) {
        const custom = processedResponse || { title: "Feito!", message: "" }
        // console.log(`\x1b[1m::: \x1b[97m\x1b[40m\x1b[30m[\x1b[97m${args.method}\x1b[30m]\x1b[0m \x1b[1m\x1b[31m${url}\x1b[0m (\x1b[1mResponse: ${httpCode}\x1b[0m):`, `\x1b[94m${JSON.stringify(custom, null, 2)}\x1b[0m`)
        resolve({ httpCode: 304, ...custom, response_headers: responseHeaders })
        return
      }

      // Converterá SUCESSOS sem JSON VÁLIDO em erros visíveis para que usuários enviem screenshots para a equipe técnica
      if (!processedResponse && typeof text === "string") {
        resolve({ httpCode: 500, title: "Atenção!", message: text, response_headers: responseHeaders })
        return
      }

      if (!processedResponse || !isHttpCodeValid(httpCode)) {
        resolve(localResponseObj("Resposta vazia ou inválida.", httpCode))
        return
      }

      // const success = httpCode === 200 || httpCode === 201 /* || httpCode === 204 || httpCode === 304 */
      // if (success) console.log(`\x1b[1m::: \x1b[97m\x1b[40m\x1b[30m[\x1b[97m${args.method}\x1b[30m]\x1b[0m \x1b[1m\x1b[31m${url}\x1b[0m (\x1b[1mResponse: ${httpCode}\x1b[0m):`, `\x1b[94m${JSON.stringify(processedResponse, null, 2)}\x1b[0m`)
      // if (!success) console.log(`\x1b[1m::: \x1b[97m\x1b[40m\x1b[30m[\x1b[97m${args.method}\x1b[30m]\x1b[0m \x1b[1m\x1b[32m${url}\x1b[0m (\x1b[1mResponse: ${httpCode}\x1b[0m):`, JSON.stringify(processedResponse, null, 2))

      // 🔴 logout automático em 401
      // if (httpCode === 401) {
        // store.dispatch(setSession({ status: 'KICKED_OUT_REQUEST' }))
      // }

      resolve({ httpCode, ...processedResponse, response_headers: responseHeaders })
    })
  }).catch(error => {
    clearTimeout(timeout)

    // AbortError → timeout
    if (error.name === "AbortError") {
      resolve(localResponseObj("A solicitação demorou e foi cancelada."))
      return
    }

    // console.log(`\x1b[1m::: \x1b[35m[${args.method}]\x1b[0m \x1b[1m\x1b[31m${url}\x1b[0m:`, "Erro na requisição", error)

    resolve(localResponseObj(error.message || "Erro desconhecido."))
  })
})

//
//
//
// PROCESSADOR XHR (FORMDATA + UPLOAD COM PROGRESSO)
//
//
//

const httpRequestXHR = (args, url) => new Promise(resolve => {
  // Set HTTP request settings
  const xhr = new XMLHttpRequest()
  xhr.open(args.method, url)

  // Default headers
  // xhr.setRequestHeader('Content-Type', 'application/json')
  // xhr.setRequestHeader('Accept', 'application/json')

  // Inserção de todos os headers do objeto
  Object.entries(args.headers || {}).forEach(([key, val]) => {
    xhr.setRequestHeader(key, val)
  })

  // Sets a 90-second timeout (1 minute and 30 seconds)
  xhr.timeout = 90000

  // progresso do upload
  if (xhr.upload && typeof args.onUploadProgress === "function") {
    xhr.upload.onprogress = event => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100)
        args.onUploadProgress(percent)
      }
    }
  }

  // Process the server response
  xhr.onload = () => {
    const httpCode = xhr.status
    // const httpCode = xhr.status || 0

    // ✅ LER HEADERS
    const rawHeaders = xhr.getAllResponseHeaders()
    const responseHeaders = {}

    rawHeaders.trim().split(/[\r\n]+/).forEach(line => {
      const parts = line.split(': ')
      const key = parts.shift()
      const value = parts.join(': ')
      if (key) responseHeaders[key.toLowerCase()] = value
    })

    if (httpCode === 204) {
      resolve({ httpCode, code: "OK", title: "Feito!", message: "", response_headers: responseHeaders })
      return
    }

    let response = xhr.responseText ? parseJson(xhr.responseText) : null

    console.log(`::: [DEBUG] ${args.method} ${url}:`, httpCode || 'load', response || xhr.responseText)

    // 304 do polling
    if (httpCode === 304) {
      const custom = response || { title: "Feito!", message: "" }
      // console.log(`\x1b[1m::: \x1b[97m\x1b[40m\x1b[30m[\x1b[97m${args.method}\x1b[30m]\x1b[0m \x1b[1m\x1b[31m${url}\x1b[0m (\x1b[1mResponse: ${httpCode}\x1b[0m):`, `\x1b[94m${JSON.stringify(custom, null, 2)}\x1b[0m`)
      resolve({ httpCode: 304, ...custom, response_headers: responseHeaders })
      return
    }

    // Converterá SUCESSOS sem JSON VÁLIDO em erros visíveis para que usuários enviem screenshots para a equipe técnica
    if (!response && typeof xhr.responseText === "string") {
      resolve({ httpCode: 500, title: "Atenção!", message: xhr.responseText })
      return
    }

    if (!response || !isHttpCodeValid(httpCode)) {
      resolve(localResponseObj("Resposta vazia ou inválida.", httpCode))
      return
    }

    // 🔴 logout automático em 401
    // if (httpCode === 401) {
      // store.dispatch(setSession({ status: 'KICKED_OUT_REQUEST' }))
    // }

    // const success = httpCode === 200 || httpCode === 201 /* || httpCode === 204 || httpCode === 304 */
    // if (success) console.log(`\x1b[1m::: \x1b[97m\x1b[40m\x1b[30m[\x1b[97m${args.method}\x1b[30m]\x1b[0m \x1b[1m\x1b[31m${url}\x1b[0m (\x1b[1mResponse: ${httpCode}\x1b[0m):`, `\x1b[94m${JSON.stringify(response, null, 2)}\x1b[0m`)
    // if (!success) console.log(`\x1b[1m::: \x1b[97m\x1b[40m\x1b[30m[\x1b[97m${args.method}\x1b[30m]\x1b[0m \x1b[1m\x1b[32m${url}\x1b[0m (\x1b[1mResponse: ${httpCode}\x1b[0m):`, JSON.stringify(response, null, 2))

    resolve({ httpCode, ...response, response_headers: responseHeaders })
    return
  }

  // Handle network failures or CORS-related issues
  xhr.onerror = () => {
    let response = parseJson(xhr.responseText)

    if (!response || !isHttpCodeValid(xhr.status)) {
      response = localResponseObj(xhr.statusText || "Falha na rede.")
    }

    resolve({ ...response, httpCode: xhr.status || 0 })
    return
  }

  // Handles the timeout case (when the response takes longer than 90s)
  xhr.ontimeout = () => {
    resolve(localResponseObj("A solicitação demorou e foi cancelada.", xhr.status || 0))
    return
  }

  // Send the HTTP request
  try
  {
    // Para FORM DATA → enviar cru
    if (args.fields instanceof FormData) {
      xhr.send(args.fields)
      return
    }

    // Para JSON normal → stringify
    if (args.fields && typeof args.fields === "object") {
      xhr.setRequestHeader("Content-Type", "application/json")
      xhr.send(JSON.stringify(args.fields))
      return
    }

    // Sem body
    xhr.send()
  }
  catch (e)
  {
    // console.log(`::: [DEBUG] ${args.method} ${url}:`, 'Erro ao enviar requisição', e)

    resolve(localResponseObj(e.message || "Erro ao enviar.", xhr.status || 0))
  }
})

//
//
//
// FUNÇÃO PRINCIPAL
//
//
//

const httpRequest = args => new Promise(resolve => {
  /* try
  { */
    // Validação inicial
    const route = typeof args.route === "string" ? args.route.replace(/^\/+/, "").trim() : ""
    const url = args.url || (route ? `${apiUrl.replace(/\/api$/, "")}/${route}` : "")

    const invalidMethod = !["GET", "POST", "PUT", "PATCH", "DELETE"].includes(args.method || "")
    const invalidUrl = !url

    if (invalidMethod || invalidUrl) {
      resolve(localResponseObj("Carga inválida."))
      return
    }

    // -------------------------------------------------------
    // 1) Verificação de internet SEM async/await
    // -------------------------------------------------------
    // const INTERNET_AVAILABILITY_TIMEOUT = 600
    // const INTERNET_AVAILABILITY_TIMEOUT = 1500
    const INTERNET_AVAILABILITY_TIMEOUT = 3000
    checkInternetAvailability(INTERNET_AVAILABILITY_TIMEOUT).then(isOnline => {
      if (!isOnline) {
        // Motivo: Sem conexão com a rede.
        resolve(offlineResponseObj())
        return
      }

      /*

      // Session token
      const sessionToken = userActions.storeGetUserSessionToken()
      // console.log("sessionToken:", sessionToken)
      if (sessionToken) args.headers["Authorization"] = `Bearer ${sessionToken}`

      */

      // -------------------------------------------------------
      // 2) Continua com o HTTP normal
      // -------------------------------------------------------
      console.log(`\x1b[1m::: \x1b[35m[${args.method}]\x1b[0m \x1b[1m\x1b[36m${url}\x1b[0m (\x1b[1mRequest\x1b[0m):`, JSON.stringify(args, null, 2))

      // Caso seja FormData → usar XHR (upload + progresso)
      if (args.fields instanceof FormData) {
        httpRequestXHR(args, url).then(resolve)
        return
      }

      // Caso contrário → usar fetch
      httpRequestFetch(args, url).then(resolve)
    })
  /* }
  catch (error)
  {
    // console.log("::: error:", error)
    resolve(localResponseObj(JSON.stringify(error)))
  } */
})

//
// EXPORTS
//

export const httpDelete = args => httpRequest({ method: "DELETE", ...args })
export const httpPatch = args => httpRequest({ method: "PATCH", ...args })
export const httpPost = args => httpRequest({ method: "POST", ...args })
export const httpGet = args => httpRequest({ method: "GET", ...args })
